
import PageLayout from "../../../layouts/PageLayout";
import StoreBrickkiln from "./StoreBrickkiln";


export default function AddNewBrickKiln() {
  

  return (
    <PageLayout>
      <StoreBrickkiln/>
    </PageLayout>
  );
}
